import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import QrInviteModal from './QrInviteModal';

const HomeShortcuts = ({items}) => {
    const navigate = useNavigate();
    const [inviteModalOpen, setInviteModalOpen] = useState(false);

    const handleClick = (item) => {
        if (item.action === 'qr-invite') {
            setInviteModalOpen(true);
            return;
        }
        navigate(item.path);
    };

    return (
        <div className="home-shortcuts-wrapper">
            <div className="header-label">Atalhos</div>
            <div className="home-shortcuts-grid">
                {items.map(item => (
                    <button
                        key={item.key}
                        type="button"
                        className="home-shortcut-button"
                        onClick={() => handleClick(item)}
                        data-test={`home-shortcut-${item.key}`}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            {inviteModalOpen && <QrInviteModal onClose={() => setInviteModalOpen(false)} />}
        </div>
    );
};

export default HomeShortcuts;
